import { useCurrentUser } from "@/features/login/hooks/useCurrentUser";
import { useLogout } from "@/features/login/hooks/useLogout";
import { ChevronDown, LogOut, KeyRound } from "lucide-react";
import { useNavigate } from "react-router";
import { DefaultLogo } from "@/features/layout/components/DefaultLogo";
import { LogoClienteFinal } from "@/shared/components/LogoClienteFinal";
import { useLogoMarcaTema } from "@/shared/hooks/useLogoMarcaTema";
import defaultLogo from "@/assets/LOGO-RETRO-IA.png";
import { Avatar, AvatarFallback } from "@/shared/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import { ThemeToggle } from "@/shared/components/ui/themeToggle";
import { useState } from "react";
import { ChangePasswordDialog } from "@retro-ia/shared/password";

export default function Header() {
  const { usuarioInfo } = useCurrentUser();
  const { mutate: logout, isPending } = useLogout();
  const navigate = useNavigate();
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const logoMarca = useLogoMarcaTema(usuarioInfo?.aprendiz?.clienteFinal);
  return (
    <header className="bg-white dark:bg-[var(--background)] border-b border-[var(--primary)] shadow-sm/25 p-3 md:p-5">
      <div className="max-w-screen mx-auto px-2 md:px-6 flex items-center justify-between gap-2 md:gap-4">
        <div className="flex items-center">
          {logoMarca ? (
            <LogoClienteFinal
              logoMarca={logoMarca}
              defaultSrc={defaultLogo}
              alt={usuarioInfo?.aprendiz?.clienteFinal?.nombreEmpresa + " logo"}
              className="h-8 md:h-12 w-auto mb-1 cursor-pointer"
              onClick={() => navigate("/programas")}
            />
          ) : (
            <div
              className="cursor-pointer"
              onClick={() => navigate("/programas")}
            >
              <DefaultLogo className="h-6 md:h-8 w-auto" />
            </div>
          )}
        </div>
        <div className="flex items-center gap-2 md:gap-3">
          <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center gap-2 md:gap-3 focus:outline-none">
              <Avatar className="h-8 w-8 md:h-10 md:w-10">
                <AvatarFallback className="text-xs md:text-sm text-black dark:text-white">
                  {usuarioInfo?.nombre?.[0]}
                  {usuarioInfo?.apellidoPaterno?.[0]}
                </AvatarFallback>
              </Avatar>
              <div className="text-left hidden sm:block">
                <p className="text-sm font-bold text-primary dark:text-primary">
                  {usuarioInfo?.nombre} {usuarioInfo?.apellidoPaterno}
                </p>
                <p className="text-xs text-black dark:text-white">
                  {usuarioInfo?.correo}
                </p>
              </div>
              <ChevronDown className="w-4 h-4 text-muted-foreground dark:text-muted-foreground" />
            </DropdownMenuTrigger>

            <DropdownMenuContent
              align="end"
              className="w-56 bg-[var(--background)] border border-[var(--primary)] shadow-md dark:bg-[var(--background)]"
            >
              <DropdownMenuItem
                onClick={() => setChangePasswordOpen(true)}
                className="cursor-pointer hover:bg-[var(--muted)] dark:hover:bg-[var(--muted)]"
              >
                <KeyRound className="w-4 h-4 mr-2" />
                Cambiar contraseña
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                onClick={() => logout()}
                disabled={isPending}
                className="cursor-pointer hover:bg-[var(--muted)] dark:hover:bg-[var(--muted)]"
              >
                <LogOut className="w-4 h-4 mr-2" />
                {isPending ? "Cerrando..." : "Cerrar sesión"}
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          <ThemeToggle />
        </div>
      </div>
      <ChangePasswordDialog
        open={changePasswordOpen}
        onOpenChange={setChangePasswordOpen}
      />
    </header>
  );
}
